.container {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 10;
	width: 100%;
	padding-top: 40px;
	padding-bottom: calc(40px - 18px);
	background-color: #f4f6f8;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 16px;
	> div {
		// width: 100%;
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		justify-content: center;
		gap: 16px 32px;
		padding-inline: 16px;
		> button {
			width: 140px;
		}
		> p {
			font-family: 'Rinsgside', sans-serif;
			font-size: 16px;
			font-weight: 700;
			line-height: 16px;
			width: fit-content;
			white-space: normal;
		}
	}
	> span {
		font-family: 'Ringside', sans-serif;
		font-size: 16px;
		height: 18px;
		transition: opacity 0.3s ease-in-out;
	}
	.select {
		position: absolute;
		top: 160px;
		right: 50%;
		width: 100%;
		transform: translateX(50%);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-flow: row wrap;
		gap: 16px;
		font-family: 'Ringside', sans-serif;
		font-size: 14px;
		* {
			cursor: pointer;
		}
		> div {
			display: flex;
			align-items: center;
			flex-flow: row nowrap;
			gap: 8px;
			input {
				width: 16px;
				height: 16px;
				margin: 0;
				accent-color: #0076a8;
			}
			label {
				white-space: nowrap;
			}
		}
	}
	button {
		span {
			span {
				text-transform: none;
				font-size: 12px;
				letter-spacing: 0px;
				line-height: 12px;
				width: max-content;
				display: inline-block;
			}
		}
	}
}

.inFlow {
	position: relative;
	min-height: 220px;
}
